import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { usePutCardCodeMutation } from '@/api/v2/cardCodes';
import { CardCode } from '@/models/cardcodes';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useNotification } from '@starjack/features/notifications';

type AddCodesProps = {
    cardCode: CardCode;
    onClose: () => void;
};

export const AddCodes: FunctionComponent<AddCodesProps> = ({
    cardCode,
    onClose,
}) => {
    const [count, setCount] = useState(0);
    const {
        liftOperatorData: { liftOperatorId },
    } = useAuthentication();
    const [putCardCode, { isLoading }] = usePutCardCodeMutation();
    const { addNotification } = useNotification();

    const onSaveCardCodes = () => {
        if (count > 0) {
            putCardCode({
                cardCodeId: cardCode.id,
                externalCode: cardCode.externalCode,
                count,
                liftOperatorId,
            })
                .unwrap()
                .then(() => {
                    addNotification({
                        type: 'success',
                        message: 'Freigabe Codes erfolgreich hinzugefügt.',
                    });
                    onClose();
                })
                .catch(() => {
                    addNotification({
                        type: 'error',
                        message:
                            'Fehler beim Speichern der Freigabe Codes. Bitte versuchen Sie es später noch einmal.',
                    });
                });
        }
    };

    const onAddCodes = (e) => {
        const { value } = e.target;

        const nextCount = parseInt(value);

        if (!isNaN(nextCount)) {
            setCount(nextCount);
        }
    };

    return (
        <Box sx={{ width: '440px' }}>
            <Box
                sx={{
                    bgcolor: 'primary.dark',
                    color: '#fff',
                    p: 4,
                }}
            >
                <Typography variant='h6'>Freigabe Codes hinzufügen</Typography>
            </Box>

            <Stack
                spacing={3}
                sx={{
                    p: 4,
                }}
            >
                <Typography>
                    Geben Sie hier die Anzahl an Freigabe Codes an, die an Ihre
                    Gäste weitergegeben werden.
                </Typography>

                <TextField
                    sx={{
                        width: 400,
                        mr: 'auto',
                    }}
                    onChange={onAddCodes}
                    label='Anzahl der Codes'
                    type='number'
                />

                <LoadingButton
                    onClick={onSaveCardCodes}
                    variant='contained'
                    loading={isLoading}
                    sx={{
                        width: '100%',
                    }}
                >
                    Speichern
                </LoadingButton>

                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                    }}
                >
                    <Button
                        sx={{
                            width: 200,
                            mx: 'auto',
                        }}
                        onClick={onClose}
                        variant='outlined'
                    >
                        Abbrechen
                    </Button>
                </Box>
            </Stack>
        </Box>
    );
};
